export default __webpack_public_path__ + "static/media/person-outlined.82fe453b.svg";